export default __webpack_public_path__ + "static/media/blue-tick.32ce6e91.svg";